// extracted by mini-css-extract-plugin
export var gallery = "Gallery-module--gallery--4c604";
export var galleryItem = "Gallery-module--gallery-item--551ce";
export var gallery__image = "Gallery-module--gallery__image--ba179";
export var gallery__imageWrapper = "Gallery-module--gallery__image-wrapper--3a037";